// import React from "react";
// import Card from "./Card";
import React from "react";
import "./CardList.css";
import { Link } from "react-router-dom";
import "./CardList.css";
import img1 from "../../../Assets/WhatsApp Image 2024-09-02 at 15.39.49_baf337a4.jpg";
import img2 from "../../../Assets/le.jpg";
import img3 from "../../../Assets/mo.jpg";
import img4 from "../../../Assets/WhatsApp Image 2024-09-02 at 12.58.58_27e1bc06.jpg";
import img5 from "../../../Assets/WhatsApp Image 2024-09-02 at 15.39.49_afc8f465.jpg";
import img6 from "../../../Assets/Instagram post of Quran arabic quotes.png";
import { useEffect } from "react";
import AOS from "aos";

const CardList = () => {
  useEffect(() => {
    AOS.init({
      duration: 3000,
    });
  });
  const courses = [
    {
        image: `${img4}`,
        title: "Basic Qaida for beginners",
        description:
          "The Noorani Qaida is a beginner's guide to learn Arabic letters and pronunciation for accurate Quran recitation.",
        link: "/Noorani-Qaida",
      },
    {
      image: `${img2}`,
        title: "Quran Recitation",
        description:
          "Quran recitation is the practice of reading the Quran with proper pronunciation, tajweed and rules, and understanding of it's divine message.",
        link: "/OnlineQuranRecitation",
    },
    {
      image: `${img3}`,
    title: "Quran memorization",
    description:
      "Quran memorization is the  practice of learning the entire Quran by heart  with accuracy .",
    link: "/Online-Quran-Memorization",
    },
    {
         image: `${img1}`,
        title: "Quran Tajweed Course",
        description:
          "Learn the art of reciting the Quran with perfect pronunciation and intonation through our comprehensive Tajweed course.",
        link: "/Quran-with-Tajweed",
    },
    {
      image: `${img5}`,
    title: "Tafseer",
    description:
      "The Quran Tafseer course provides in-depth insights into the meanings and context of the Quran.",
    link: "/Tafseer",
    },
    {
      image: `${img6}`,
    title: "Quran Translation",
    description:
      "Quran Translation provides easy-to-understand meanings and accurate interpretations of the Quran verses",
    link: "/Quran-Translation",
    },
  ];

  return (
    <div className="course-container container">
      <h1 className="course-title text-center mt-4 mb-4">FEATURED COURSES</h1>
      <div className="course-grid">
        {courses.map((course) => (
          <div key={course.id} className="course-card" data-aos="zoom-in">
            <img src={course.image} alt={course.title} className="course-image" />
            <h2 className="course-card-title">{course.title}</h2>
            <p className="course-description">{course.description}</p>
            <button className="course-btn">
              <Link to={course.link} className="btn-Link">Learn More</Link>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardList;

